import {
  AfterContentInit,
  Component,
  ComponentFactoryResolver,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../../../../services/http.service";
import { ShareService } from "../../../../services/share.service";
import { DesignerComponent } from "../cp-designer/designer.component";
import { LocalesComponent } from "../locales/locales.component";
import { DynamicTabsDirective } from "./dynamic-tabs.directive";
import { TabComponent } from "./tab.component";
declare let $: any;
@Component({
  selector: "app-tabs",
  template: `
    <ul class="tabview nav nav-tabs">
      <li class="tabview_tab" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
        <a>{{ tab.title }}</a>
      </li>
    </ul>
    <ng-content></ng-content>
  `,
  styleUrls: ["./tabs.component.scss"]
})
export class TabsComponent implements AfterContentInit {
  dynamicTabs: TabComponent[] = [];
  selectedTab;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  @ViewChild(DynamicTabsDirective) dynamicTabPlaceholder: DynamicTabsDirective;

  @ViewChild("container") allTabs;

  @Input() elementsList;
  @Input() views;
  @Input() selectedLocale;

  @Output() sendSelectedLocale = new EventEmitter();
  @Output() selectedView = new EventEmitter();

  /*
    Alternative approach of using an anchor directive
    would be to simply get hold of a template variable
    as follows
  */

  // @ViewChild('container', {read: ViewContainerRef}) dynamicTabPlaceholder;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private uploadService: HttpService,
    private shareService: ShareService,
    private designerComponent: DesignerComponent,
    private localesComponent: LocalesComponent,
    private router: Router
  ) {}

  // contentChildren are set
  ngAfterContentInit() {
    // console.log(this.views);
    this.shareService.sendActiveTab(this.tabs);
    // get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);
    // if there is no active tab set, activate the first
    /*setTimeout(() => {
      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.first);
      }
    }, 100);*/
  }

  public clearTabs() {
    this.tabs = new QueryList<TabComponent>();
  }

  openTab(title: string, template, data, isCloseable = false) {
    // get a component factory for our TabComponent
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
      TabComponent
    );

    // fetch the view container reference from our anchor directive
    const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;

    // alternatively...
    // let viewContainerRef = this.dynamicTabPlaceholder;

    // create a component instance
    const componentRef = viewContainerRef.createComponent(componentFactory);

    // set the according properties on our component instance
    const instance: TabComponent = componentRef.instance as TabComponent;
    instance.title = title;
    instance.template = template;
    instance.dataContext = data;
    // instance.isCloseable = isCloseable;

    // remember the dynamic component for rendering the
    // tab navigation headers
    this.dynamicTabs.push(componentRef.instance as TabComponent);
    // set it active
    this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);

  }

  selectTab(tab: TabComponent) {
    // deactivate all tabs
    this.tabs.toArray().forEach(tab => (tab.active = false));
    this.dynamicTabs.forEach(tab => (tab.active = false));
    // activate the tab the user has clicked on.
    if (this.router.url === "/main/(sub:shared)") {
      const selectedView = this.views.find(view => view.viewName === tab["title"]);
      this.selectedView.emit(selectedView);
      this.loadImg(tab, "#logo_id", "logo");
      if (selectedView && !selectedView.withVideo) {
        this.loadImg(tab, "#login_image_id_1", "splashImage");
        this.loadImg(tab, "#login_image_id_2", "splashImage");
      }
      if (tab["title"] === "Ads page") {
        this.loadImg(tab, "#ad_img_id_1", "adImgId1");
        this.loadImg(tab, "#ad_img_id_2", "adImgId2");
        this.loadImg(tab, "#ad_img_id_3", "adImgId3");
        this.loadImg(tab, "#ad_img_id_4", "adImgId4");
        this.loadImg(tab, "#ad_img_id_5", "adImgId5");
        this.loadImg(tab, "#ad_img_id_6", "adImgId6");
      }
    }
    tab.active = true;
    this.shareService.sendOnlyActive(tab);

    if (this.router.url === "/main/(sub:locales)") {
      for (let i = 0; i < this.localesComponent.elementsNames.length; i++) {
        if (this.localesComponent.elementsNames[i] === tab.title) {
          // console.log(Object.keys(this.localesComponent.elementsList)[i]);
          this.sendLocale(Object.keys(this.localesComponent.elementsList)[i]);
        }
      }
      // for (const property in this.elementsList) {
      //   if (this.elementsList.hasOwnProperty(property)) {
      //     if (this.camelize(tab.title.toLowerCase()) === property) {
      //       this.sendLocale(property);
      //     }
      //   }
      // }
    }
  }

  sendLocale(prop?) {
    this.sendSelectedLocale.emit(prop);
  }

  // camelize(str) {
  //   return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
  //     return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  //   }).replace(/\s+/g, '');
  // }

  private loadImg(tab, id, tag) {
    // console.log(tab, id, tag);
    const currTemplate = this.designerComponent.getCurrTemplate();
    const currView = currTemplate.views.filter(function(el) {
      return el.viewName === tab["title"];
    })[0];
    const src = document.querySelectorAll(id);
    $("#login_iframe_id_2 #remove_id_2").css("display", "block");
    $("#login_iframe_id_1 #remove_id_1").css("display", "block");
    this.uploadService
      .getFiles(currView.viewId, tag, currTemplate.id)
      .subscribe(data => {
        // console.log("images", data);
        for (let i = 0; i < src.length; i++) {
          src[i].setAttribute(
            "src",
            "data:image/JPEG;base64," + `${data.payload.img}`
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/tabs/tabs.component.ts